export const getStrWithoutSpaces = (text: string) =>
  (text || '').trim().replace(/\s/g, '').toLowerCase()
